import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setPlacingMoneySource, EMoneySource } from '../../../../../redux/reducers';

export const useSubAgentMasterLimitExceed = () => {
  const dispatch = useDispatch();

  const handleSwitchToSelfPlacingMoneySource = useCallback(() => {
    dispatch(setPlacingMoneySource(EMoneySource.Self));
  }, [dispatch]);

  return { handleSwitchToSelfPlacingMoneySource };
};
